import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

import Testimonia from "../../../assets/image/testimonial2.png";
import Testimonia1 from "../../../assets/image/testimonial3.png";
import Bgchose from "../../../assets/image/pattern-4.png"

const testimonials = [
   {
        id: 1,
        title: "Canada Immigration",
        name: "Tanya Benson",
        location: "California, USA",
        image: Testimonia,
        rating: 5,
        text: "“Thanks to Trinity, I obtained my student visa with ease. Their team helped me secure admission and complete the process smoothly.”"
    },

    {
        id: 2,
        title: "Green Card Approved",
        name: "James Thomas",
        location: "California, USA",
        image: Testimonia1,
        rating: 5,
        text: "“Trinity helped me restore my status and regain stability. I’m grateful for their consistent support.” "
    },
    {
        id: 3,
        title: "Canada Immigration",
        name: "Tanya Benson",
        location: "California, USA",
        image: Testimonia,
        rating: 5,
        text: "“Thanks to Trinity, I obtained my student visa with ease. Their team helped me secure admission and complete the process smoothly.”"
    },


       {
        id: 4,
        title: "Green Card Approved",
        name: "James Thomas",
        location: "California, USA",
        image: Testimonia1,
        rating: 5,
        text: "“Trinity helped me restore my status and regain stability. I’m grateful for their consistent support.” "
    }
];

const Testimonials = () => {
    return (
        <section

            className="relative  bg-[#eff2f5]  py-10 md:py-20  bg-cover bg-center bg-no-repeat"
            style={{
                backgroundImage: `url(${Bgchose})`,
            }}>
            <div className="max-w-7xl mx-auto px-4">

                {/* Heading */}
                <div className="text-center mb-14">
                    <p className="uppercase tracking-widest font-[600] text-white">
                     Client Testimonials


                    </p>
                    <h2 className="text-3xl md:text-5xl font-bold text-white my-6">
                       What Our
 <br /> Clients Are Saying
                    </h2>

                    <div className="flex gap-2 items-center justify-center">
                        <div className="w-12 h-1 bg-white rounded"></div>
                        <div className="w-1 h-1 bg-white rounded"></div>
                        <div className="w-1 h-1 bg-white rounded"></div>
                        <div className="w-1 h-1 bg-white rounded"></div>
                    </div>
                </div>

                {/* Swiper */}
                <Swiper
                    modules={[Pagination, Autoplay]}
                    pagination={{ clickable: true }}
                    autoplay={{ delay: 3500, disableOnInteraction: false }}
                    speed={900}
                    spaceBetween={0}
                    slidesPerView={2}
                    breakpoints={{
                        0: { slidesPerView: 1 },
                        1024: { slidesPerView: 2 },
                    }}
                    className="testimonial-swiper hidden"
                >
                    {testimonials.map((item) => (
                        <SwiperSlide key={item.id}>
                            <div
                                className="
                  border rounded-lg px-6 py-10 md:px-8 md:py-14 bg-white h-full
                  transition-all duration-700 ease-out
                  opacity-1 scale-95
                  swiper-slide-active:opacity-100
                  swiper-slide-active:scale-100
                "
                            >
                                <div className="flex flex-col sm:flex-row gap-6 sm:gap-8 items-center  min-h-[150px] ">

                                    {/* LEFT PROFILE */}
                                    <div className="flex flex-col items-center text-center sm:min-w-[120px]">
                                        <img
                                            src={item.image}
                                            alt={item.name}
                                            className="w-20 h-20 rounded-full object-cover mb-3"
                                        />
                                        <h4 className="font-semibold text-black">
                                            {item.name}
                                        </h4>
                                        <p className="text-sm text-gray-500 italic">
                                            {item.location}
                                        </p>
                                    </div>

                                    {/* RIGHT CONTENT */}
                                    <div className="flex-1">
                                        <div className="flex flex-wrap items-center gap-3 mb-3">
                                            <h5 className="font-semibold text-[#2d5883]">
                                                {item.title}
                                            </h5>
                                            <div className="flex gap-1">
                                                {[...Array(item.rating)].map((_, i) => (
                                                    <span key={i} className="text-yellow-400 text-sm">
                                                        ★
                                                    </span>
                                                ))}
                                            </div>
                                        </div>

                                        <p className="text-[#555] text-[15px] leading-[28px]">
                                            {item.text}
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

            </div>
        </section>
    );
};

export default Testimonials;
